import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scrollTop:0
  },
  mutations: {
    increment(state,data) {
      state.scrollTop = data;
    }
  },
  actions: {

  }
})
